interface CustomStatusBadgeProps {
  status: string;
}

const CustomStatusBadge: React.FC<CustomStatusBadgeProps> = ({ status }) => {
  const backgroundColor = status === "Active" ? "#06A3B04D" : "#D0A6CD66";

  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 20px",
        borderRadius: "100px",
        backgroundColor,
      }}
    >
      {status}
    </span>
  );
};

export default CustomStatusBadge;
